import { initSentryBrowser } from '@nrx/error-tracking-web';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app.js';
import { captureAttribution } from './lib/attribution/attribution.js';
import { ensureFunnelId } from './lib/funnel/funnel-id.js';
import './index.css';

// FFS-MNT DTC signup — fully unauthenticated. No auth provider, no Cognito.
// Sentry must initialise before the app renders (mirrors the backend instrument-first rule).
initSentryBrowser({
  dsn: import.meta.env['VITE_SENTRY_DSN'],
  environment: import.meta.env['VITE_SENTRY_ENVIRONMENT'],
  release: import.meta.env['VITE_SENTRY_RELEASE'],
  app: 'ffs-signup',
});

// Before render: the Stripe 3DS resume path wipes the query string on mount.
captureAttribution(window.location);
// Every visitor, attributed or organic: the key that joins a check to the enrollment that follows.
ensureFunnelId();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
